import ChevronDownIcon from '@eduzz/houston-icons/ChevronDown';
import { useFormikContext } from 'formik';
import * as React from 'react';
import TextFormField from 'v2/components/Shared/FormFields/TextFormField';

import type { TextFieldProps } from 'v2/components/Shared/FormFields/TextFormField';

import { useStyles } from './styles';

type InputProps = Omit<TextFieldProps, 'form' | 'field' | 'meta'>;

function Input({ name, helperText, ...props }: InputProps) {
  const classes = useStyles();

  const form = useFormikContext();

  return (
    <TextFormField
      id={name}
      form={form}
      field={form.getFieldProps(name)}
      meta={form.getFieldMeta(name)}
      className={classes.root}
      helperText={typeof helperText === 'string' ? <span className={classes.helperText}>{helperText}</span> : helperText}
      variant='outlined'
      inputProps={{
        ['data-testid']: name,
      }}
      InputLabelProps={{ shrink: true }}
      SelectProps={{
        IconComponent: () => <ChevronDownIcon className={classes.selectIcon} size={20} />,
        MenuProps: {
          classes: {
            paper: classes.selectMenuPaper,
            list: classes.selectMenuList,
          },
        },
      }}
      FormHelperTextProps={{
        className: classes.defaultHelperText,
      }}
      fullWidth
      {...props}
    />
  );
}

export { Input };
